import dashboardEN from "./dashboard";
import menuAboutEN from "./menuAbout";
import labelsEN from "./labels";
import releasesEN from "./releases";
import artistsEN from "./artists";
import artistsWishlistEN from "./artistsWishlist";
import profileEN from "./profile";
import musicLinksEN from "./musicLinks";
import linkLandingPagesEN from "./linkLandingPages";
import masteringEN from "./mastering";
import featureEN from "./feature";
import accountingEN from "./accounting";
import paymentMethodsEN from "./paymentMethods";
import purchaseHistoryEN from "./purchaseHistory";
import trendsEN from "./trends";
import earningsDrilldownEN from "./earningsDrilldown";
import invoicesEN from "./invoices";
import statementsEN from "./statements";
import subuserStatementsEN from "./subuserStatements";
import creditsEN from "./credits";
import userDataFormEN from "./userDataForm";
import disputeClaimsEN from "./disputeClaims";
import musicLinkUrlPartsEN from "./musicLinkUrlParts";
import subscriptionEN from "./subscription";
import twoFactorAuthEN from "./twoFactorAuth";
import generalEN from "./general";
import routerEN from "./router";
import escrowWalletEN from "./escrowWallet";
import subUsersEN from "./subUsers";
import tokensEN from "./tokens";
import tracksEN from "./tracks";
import acrAlertEN from "./acrAlert";
import qcNoteEN from "./qcNote";
import flaggedContentEN from "./flaggedContent";
import deliveryConfirmationEN from "./deliveryConfirmation";
import preScanEN from "./preScan";
import accessKeysEN from "./accessKeys";
import announcementsEN from "./announcements";

const translationEN = {
    "router": routerEN,
    "general": generalEN,
    "dashboard": dashboardEN,
    "menuAbout": menuAboutEN,
    "labels": labelsEN,
    "artists": artistsEN,
    "artistsWishlist": artistsWishlistEN,
    "releases": releasesEN,
    "tracks": tracksEN,
    "profile": profileEN,
    "musicLinks": musicLinksEN,
    "musicLinkUrlParts": musicLinkUrlPartsEN,
    "linkLandingPages": linkLandingPagesEN,
    "mastering": masteringEN,
    "feature": featureEN,
    "accounting": accountingEN,
    "paymentMethods": paymentMethodsEN,
    "purchaseHistory": purchaseHistoryEN,
    "trends": trendsEN,
    "earningsDrilldown": earningsDrilldownEN,
    "invoices": invoicesEN,
    "statements": statementsEN,
    "subuserStatements": subuserStatementsEN,
    "credits": creditsEN,
    "userDataForm": userDataFormEN,
    "disputeClaims": disputeClaimsEN,
    "subscription": subscriptionEN,
    "twoFactorAuth": twoFactorAuthEN,
    "escrowWallet": escrowWalletEN,
    "subUsers": subUsersEN,
    "tokens": tokensEN,
    "acrAlert": acrAlertEN,
    "qcNote": qcNoteEN,
    "flaggedContent": flaggedContentEN,
    "deliveryConfirmation": deliveryConfirmationEN,
    "preScan": preScanEN,
    "accessKeys": accessKeysEN,
    "announcements": announcementsEN,
};

export default translationEN;